import type { IconData } from '@stacksjs/iconify-core'

export const underline: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.5 10h7a.5.5 0 1 1 0 1h-7a.5.5 0 1 1 0-1M7 2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2v3a4 4 0 1 1-8 0V2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2v3a2 2 0 1 0 4 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default underline
